import type { CSSObject, Theme } from '@mui/material';
import { Drawer, styled } from '@mui/material';

import { drawerWidth } from 'themeConfig';

const openedMixin = (theme: Theme): CSSObject => ({
    width: drawerWidth,
    borderRight: `1px solid ${theme.palette.divider}`,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    boxShadow: 'none',
});

const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: 0,
    borderRight: 'none',
    boxShadow: theme.shadows[4],
});

interface MiniDrawerProps {
    open: boolean;
}

const MiniDrawerStyled = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })<MiniDrawerProps>(({ theme, open }) => {
    const openedStyles = openedMixin(theme);
    const closedStyles = closedMixin(theme);

    return {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedStyles,
            '& .MuiDrawer-paper': openedStyles,
        }),
        ...(!open && {
            ...closedStyles,
            '& .MuiDrawer-paper': closedStyles,
        }),
    };
});

export default MiniDrawerStyled;
